import React, { useState, useEffect } from 'react';
import '../styles/components/_adminAuth.scss';

/**
 * Composant d'authentification pour l'admin
 * Protège l'accès à la page /admin avec un mot de passe
 */

const ADMIN_PASSWORD = process.env.REACT_APP_ADMIN_PASSWORD || 'overwatch';
const AUTH_KEY = 'admin_authenticated';
const AUTH_EXPIRY_KEY = 'admin_auth_expiry';

// Durée de validité de la session : 24 heures
const SESSION_DURATION = 24 * 60 * 60 * 1000;

function AdminAuth({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  // Vérifier si l'utilisateur est déjà authentifié au chargement
  useEffect(() => {
    const checkAuth = () => {
      const authStatus = localStorage.getItem(AUTH_KEY);
      const expiry = localStorage.getItem(AUTH_EXPIRY_KEY);

      if (authStatus === 'true' && expiry) {
        const expiryTime = parseInt(expiry, 10);
        const now = Date.now();

        if (now < expiryTime) {
          // Session valide
          setIsAuthenticated(true);
        } else {
          // Session expirée
          localStorage.removeItem(AUTH_KEY);
          localStorage.removeItem(AUTH_EXPIRY_KEY);
        }
      }

      setIsLoading(false);
    };

    checkAuth();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    if (password === ADMIN_PASSWORD) {
      // Authentification réussie
      const expiry = Date.now() + SESSION_DURATION;
      localStorage.setItem(AUTH_KEY, 'true');
      localStorage.setItem(AUTH_EXPIRY_KEY, expiry.toString());
      setIsAuthenticated(true);
      setPassword('');
    } else {
      // Mot de passe incorrect
      setError('Mot de passe incorrect');
      setPassword('');
    }
  };

  const handleLogout = () => {
    localStorage.removeItem(AUTH_KEY);
    localStorage.removeItem(AUTH_EXPIRY_KEY);
    setIsAuthenticated(false);
  };

  if (isLoading) {
    return (
      <div className="admin-auth-loading">
        <div className="spinner"></div>
        <p>Vérification...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <div className="admin-auth-container">
        <div className="admin-auth-box">
          <div className="admin-auth-header">
            <h1>🔒 Accès Admin</h1>
            <p>Authentification requise</p>
          </div>

          <form onSubmit={handleSubmit} className="admin-auth-form">
            <div className="form-group">
              <label htmlFor="password">Mot de passe</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Entrez le mot de passe"
                autoFocus
                autoComplete="current-password"
              />
            </div>

            {error && (
              <div className="error-message">
                ⚠️ {error}
              </div>
            )}

            <button type="submit" className="submit-btn">
              Se connecter
            </button>
          </form>

          <div className="admin-auth-footer">
            <p>Session valide : 24 heures</p>
          </div>
        </div>
      </div>
    );
  }

  // Utilisateur authentifié, afficher le contenu admin
  return (
    <>
      <div className="admin-auth-bar">
        <span>✅ Connecté en tant qu'administrateur</span>
        <button onClick={handleLogout} className="logout-btn">
          Déconnexion
        </button>
      </div>
      <div className="admin-content-with-auth">
        {children}
      </div>
    </>
  );
}

export default AdminAuth;
